import type { Rule } from 'antd/es/form';
import type { ReactNode } from 'react';

export type FieldType = 'text' | 'password' | 'textarea' | 'select' | 'number' | 'url';

export interface SelectOption {
    value: string | number | null;
    label: string;
}

export interface BaseFieldConfig {
    name: string | string[];
    label: string;
    type: FieldType;
    required?: boolean;
    placeholder?: string;
    extra?: string;
    initialValue?: unknown;
    rules?: Rule[];
    hidden?: boolean;
    isCredential?: boolean; // Mark fields as credential fields (passwords, tokens, keys)
    keepPlaceholderInEditMode?: boolean; // If true, keeps the custom placeholder in edit mode instead of "Leave empty to keep current value"
}

export interface TextFieldConfig extends BaseFieldConfig {
    type: 'text' | 'url';
}

export interface PasswordFieldConfig extends BaseFieldConfig {
    type: 'password';
}

export interface TextAreaFieldConfig extends BaseFieldConfig {
    type: 'textarea';
    rows?: number;
}

export interface SelectFieldConfig extends BaseFieldConfig {
    type: 'select';
    options: SelectOption[];
    showSearch?: boolean;
    onChange?: (value: unknown) => void;
}

export interface NumberFieldConfig extends BaseFieldConfig {
    type: 'number';
    min?: number;
    max?: number;
}

export type FieldConfig =
    | TextFieldConfig
    | PasswordFieldConfig
    | TextAreaFieldConfig
    | SelectFieldConfig
    | NumberFieldConfig;

export interface FormSection {
    title?: string;
    fields: FieldConfig[];
    collapsible?: boolean;
    defaultOpen?: boolean;
}

export interface ConnectionTestResult {
    success: boolean;
    message: string;
    resources?: string[];
    available_resources?: string[];
    validation_details?: Record<string, unknown>;
}

export interface ConfigFormProps {
    children?: ReactNode;
}
